import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', name: 'dashboard', component: () => import('./pages/DashboardPage.vue') },
    { path: '/evidence', redirect: '/evidence/basis' },
    { path: '/evidence/basis', name: 'basis', component: () => import('./pages/BasisPage.vue') },
    { path: '/evidence/positions', name: 'positions', component: () => import('./pages/PositionsPage.vue') },
    { path: '/evidence/options', name: 'options', component: () => import('./pages/OptionsPage.vue') },
    { path: '/review', name: 'review', component: () => import('./pages/ReviewPage.vue') },
    { path: '/settings', name: 'settings', component: () => import('./pages/SettingsPage.vue') }
  ]
})

export default router
